import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule, ModalModule } from 'snl-complib';

@Component({
  selector: 'app-publish-ccd-popup',
  standalone: true,
  imports: [ModalModule, ButtonModule, CommonModule],
  templateUrl: './publish-ccd-popup.component.html',
  styleUrl: './publish-ccd-popup.component.scss'
})
export class PublishCcdPopupComponent {
  disableSaveButton:boolean = true;
  showErrorMessage: boolean = false;
  modalSettings: any;

  @Input() open: boolean = false;
  @Input() ccdNo: string = '';
  @Input() publishPopupSubmitLoading: boolean = false;
  @Output() onButtonClick: EventEmitter<any | null> = new EventEmitter();

  ngOnInit(){
    this.modalSettings = { showCloseIcon: true, backdropClick: false };
  }

  closeModalPopUp() {
    this.onButtonClick.emit({}) 
  }

  cancelEditCcdAndCloseModalPopUp() {
      this.onButtonClick.emit({
        isPublishCcd: true
      });
  }
}
